
const url = "~0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
let counter = Date.now();

function encodePart(input:number):string{
	let result = '';
	do{
		result = url[input % url.length] + result;
		input = Math.floor(input / url.length);
	}while(input);
	return result;
}


function genId() {
    let cc = counter++;
    let datePart = Date.now();
	let randomPart = Math.floor(Math.random() * 1000000);
	let result = [cc,datePart, randomPart]
		.map(n=>encodePart(n))
		.join("");
	return result;
}

export { genId }